import classNames from "classnames";
import { CircularProgress } from "@circle-react/components/shared/uikit/TipTap/AttachmentPreviews/CircularProgress";
import { Icon } from "@circle-react-shared/Icon";
import type { ToastVariant } from "./interfaces";

export interface ProgressIconProps {
  isIndefinite?: boolean;
  progress: number;
  variant?: ToastVariant;
}

export const ProgressIcon = ({
  progress,
  variant,
  isIndefinite,
}: ProgressIconProps) => {
  const isDangerVariant = variant === "danger";

  if (progress === 100) {
    return (
      <span className="flex size-5">
        <Icon
          type="20-checkmark-circle-fill"
          size={20}
          className={classNames("text-circle-button", {
            "!text-white": isDangerVariant,
          })}
        />
      </span>
    );
  }

  return (
    <span
      className={classNames("flex size-5 items-center justify-center", {
        "animate-spin-fast": isIndefinite,
      })}
    >
      <CircularProgress
        percentage={isIndefinite ? 50 : progress}
        size={18}
        strokeWidth={1.75}
        backgroundCircleClassName={classNames({
          "!text-red-800": isDangerVariant,
        })}
        foregroundCircleClassName={classNames("!text-circle-button", {
          "!text-white": isDangerVariant,
        })}
      />
    </span>
  );
};
